import BaseStore from '@haskoning/vue-basestore'
import {pinia} from "@/modules/pinia.js";
const {api} = useFeathers()
const snackbarStore = useSnackbarStore(pinia)

const baseStore = new BaseStore('object-classification-fields', api, snackbarStore);


export const useObjectClassificationFieldStore = defineStore('objectClassificationField', {
    state: () => ({
        ...baseStore.state,
    }),
    actions: {
        ...baseStore.actions,
    },
})
